/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import PropTypes from 'prop-types';
import { formatPhone } from '../../lib/LocationDetailsUtils';
import { RESOURCE_BASE_URL } from '../../constants/index';
import './ServiceOverlay.scss';
import OverlayPictureMobile from '../../static/img/service--mobile.png';
import OverlayPictureDesktop from '../../static/img/service--desktop.png';
import roadsideAssistancePhoneNumbers from '../../data/roadAssistancePhoneNumbers';

const ServiceOverlay = props => {
  const content = props.content.card;
  const { active, country } = props;

  return (
    <div
      className={`overlay overlay--service ${active ? 'overlay--active' : ''}`}
      ref={props.setRef}
    >
      <div className="overlay-header">
        <picture className="overlay-picture">
          <source
            media="(max-width: 840px)"
            srcSet={`${RESOURCE_BASE_URL}${OverlayPictureMobile}`}
          />
          <source
            media="(min-width: 839px)"
            srcSet={`${RESOURCE_BASE_URL}${OverlayPictureDesktop}`}
          />
          <img
            className="overlay-image"
            src={`${RESOURCE_BASE_URL}${OverlayPictureDesktop}`}
            alt="overlay desktop"
          />
        </picture>
        <h1 className="overlay-title">{content.header}</h1>
        <button
          className="btn btn--icon"
          type="button"
          onClick={props.handleCloseClick}
          aria-label="button cancel"
        >
          <i className="icon icon--cancel" />
        </button>
      </div>
      <div className="overlay-body">
        <p
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: `${props.description}` }}
          className="overlay-description"
        />
        <a
          className="tsla-btn tsla-btn--blue"
          href={props.link}
          target="_blank"
          rel="noreferrer noopener"
        >
          {content.button.label}
        </a>
        <div className="roadside">
          <p className="roadside-description">{content.roadside.text}</p>
          <p className="roadside-phone">
            <a
              className="roadside-link"
              href={`tel:${formatPhone(roadsideAssistancePhoneNumbers[country])}`}
            >
              {roadsideAssistancePhoneNumbers[country]}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

ServiceOverlay.defaultProps = {
  content: {},
};

ServiceOverlay.propTypes = {
  active: PropTypes.bool.isRequired,
  country: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object,
  handleCloseClick: PropTypes.func.isRequired,
  setRef: PropTypes.func.isRequired,
};

export default ServiceOverlay;
